module.exports = __webpack_public_path__ + "img/Large-2-Bevel-Attachment-47.cbb6f320.png";